export const useDocumentRect = () => {
  var defaultRect = {
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    bottom: 0,
    right: 0,
  };

  try {
    var documentContainerElement =
      document.getElementById("document-container");

    if (documentContainerElement == undefined) return defaultRect;

    var documentRect = documentContainerElement.getBoundingClientRect();

    if (documentRect == undefined) return defaultRect;

    return documentRect;
  } catch (error) {
    return defaultRect;
  }
};
